import React, { useRef, useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import AxiosClient from '../../assets/AxiosClient';
import { DEFAULT_CONFERENCE_ID, useStateContext } from '../../Contexts/ContextProvider';
import Loader from '../../assets/tools/Loder/loader';
import ToggleSwitch from '../../Models/ToggleSwitch';

const EditFile = () => {
  const { SetNotification } = useStateContext();
  const { id } = useParams(); // Retrieve file ID from URL params
  const titleRef = useRef(null);
  const descriptionRef = useRef(null);
  const [active, setActive] = useState(null);
  const [lang, setLang] = useState("English");
  const [sending, setIsSending] = useState(false);
  const [loading, setIsloading] = useState(true);

  const [initialData, setInitialData] = useState(null);
  const [conferenceId, setConferenceId] = useState(DEFAULT_CONFERENCE_ID);
  
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFileData = async () => {
      try {
        const response = await AxiosClient.get(`/public-files/${id}`);
        setInitialData(response.data); // Store existing file data in state
        console.log(response.data) ; 
      } catch (error) {
        console.error('Error fetching file data:', error);
      }finally{
        setIsloading(false);
      }
    };

      fetchFileData(); // Fetch data only if ID is present (indicating edit mode)
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSending(true);
    const payload = {
      title: titleRef.current.value,
      description: descriptionRef.current.value,
      conference_id: conferenceId,
      active: active,
      lang: lang,
    };


    try {
      if (id) {
        await AxiosClient.put(`/public-files/${id}`, payload);
        SetNotification('File updated successfully', 'success');
        navigate(-1);
      } 
     
    } catch (error) {
      if (error.response && error.response.data && error.response.data.message) {
        const errorMessage = error.response.data.message;
        SetNotification(errorMessage, 'danger');
      } else {
        SetNotification('An error occurred while processing the file.', 'danger');
      }
    }

    setIsSending(false);
  };
  const handleDelete = async ()=>{
    const confirmed = window.confirm('Are you sure you want to delete this File  ?');
    if (!confirmed) return ; 
    try {
      await AxiosClient.delete(`/public-files/${id}`);
      SetNotification('File Deleted successfully', 'warning');

      navigate(-1);

    } catch (error) {
      console.error(error);
    }
  }

  // Populate form fields with existing file data for editing
  useEffect(() => {
    if (initialData) {
      console.log(initialData);
      titleRef.current.value = initialData.title;
      descriptionRef.current.value = initialData.description;
      setConferenceId(initialData.conference_id)
      setActive(initialData.active);
      setLang(initialData.lang);
    }
  }, [initialData]);

  if (loading ) {
    return <Loader label="Loading file details..." />;
  }

  return (
    <div className="m-4">
      <h2>Edit File</h2>
      <h5>Language</h5>
        <button
          className={`btn btn-${lang === "Arabic" ? 'info' : 'dark'} m-2`}
          onClick={() => setLang("Arabic")}
        >
          Arabic
        </button>
        <button
          className={`btn btn-${lang === "English" ? 'info' : 'dark'} m-2`}
          onClick={() => setLang("English")}
        >
          English
        </button>
        {lang === 'Arabic' ? (
          <img src="https://flagsapi.com/IQ/shiny/64.png" alt="Arabic Flag" />
        ) : (
          <img src="https://flagsapi.com/GB/shiny/64.png" alt="English Flag" />
        )}
      <form className="form-group" >
       

        <h5>Title</h5>
        <div className="input-group input-group-outline mb-3">
          <input
            type="text"
            className="form-control"
            placeholder="Enter title"
            ref={titleRef}
          />
        </div>

        <h5>Description</h5>
        <div className="input-group input-group-outline mb-3">
          <textarea
            className="form-control"
            placeholder="Enter description"
            rows={5}
            ref={descriptionRef}
          />
        </div>

        <hr className="border-gray-300 my-4" />

        <div className="w-full flex flex-wrap items-center">Is the File Public?</div>
        <ToggleSwitch state={active  } updateIsActive={setActive} />

        {sending ? (
          <h1>Sending...</h1>
        ) : (
          <button onClick={handleSubmit} type="submit" className="btn btn-primary">
            Submit
          </button>
        )}
       
      </form>
      <div className='text-end'> 

      
      {sending ? (
          <h1>Sending...</h1>
        ) : (
          <button onClick={handleDelete} type="submit" className="btn  m-2 text-lg btn-danger">
             Delete the File 
          </button>
        )}
        </div>
    </div>
  );
};

export default EditFile;
